<script>
import GraphicArea from '@/components/GraphicArea.vue'
import http from '@/utils/http'

export default {
  name: 'ShowEquipamentoGraficos',
  components: { GraphicArea },
  props: {
    equipamentoId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    sensores: null,
    fetchingSensores: false,
    tiposSensores: {},
    filtro: {
      dataInicio: null,
      dataFinal: null,
      offset: null,
      range: null,
    },
  }),
  async beforeMount() {
    await this.loadTiposSensores()
      // eslint-disable-next-line no-unused-vars
      .then((e) => this.limparFiltro())
  },
  methods: {
    loadTiposSensores() {
      return http.get('tiposSensores').then((response) => {
        this.tiposSensores = response.tiposSensores.reduce((acc, e) => {
          acc[e.tipo] = e
          return acc
        }, {})
      })
    },
    limparFiltro() {
      this.filtro = {
        offset: this.milliseconds(2, 'hora'),
        dataInicio: null,
        dataFinal: null,
        range: 1000 * 60 * 60 * 2,
        maxValue: new Date().getTime(),
      }

      this.fetchSensores()
    },
    async fetchSensores() {
      this.fetchingSensores = true

      let url = `equipamento/${this.equipamentoId}/sensores?`

      if (this.filtro.dataInicio && this.filtro.dataFinal) {
        const dataInicioISO = new Date(this.filtro.dataInicio).toISOString()

        const finalDate = new Date(this.filtro.dataFinal)
        finalDate.setHours(23, 59, 59, 999)
        this.filtro.maxValue = finalDate.getTime()

        const now = new Date()

        if (
          finalDate.getDay() === now.getDay() &&
          finalDate.getMonth() === now.getMonth() &&
          finalDate.getFullYear() === now.getFullYear()
        ) {
          this.filtro.range =
            new Date() - new Date(this.filtro.dataInicio).getTime()
        } else {
          this.filtro.range =
            this.filtro.maxValue - new Date(this.filtro.dataInicio).getTime()
        }

        finalDate.setHours(0)
        const dataFinalISO = finalDate.toISOString()

        url += `dataInicio=${dataInicioISO}&dataFinal=${dataFinalISO}`
      } else if (this.filtro.offset) {
        this.filtro.range = this.filtro.offset
        url += `periodo=${new Date(
          new Date().getTime() - this.filtro.offset
        ).toISOString()}`
      }

      const response = await http.get(url)
      if (!response) {
        return
      }

      let tipos = Object.keys(response.sensores)

      tipos = tipos.sort(
        (a, b) =>
          (this.tiposSensores[a]?.prioridade ?? 0) -
          (this.tiposSensores[b]?.prioridade ?? 0)
      )

      // Ordena os tipos de sensores
      this.sensores = tipos.map((tipo) => [
        new Date().valueOf(),
        tipo,
        response.sensores[tipo],
      ])
      this.fetchingSensores = false
    },
    milliseconds(n, unidade) {
      switch (unidade) {
        case 'min':
          return 1000 * 60 * n
        case 'hora':
          return 1000 * 60 * 60 * n
        default:
          return 0
      }
    },
  },
}
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12 col-md-2">
        <md-field style="border-bottom: none">
          <label for="sensor-filtro">Filtro rápido</label>
          <md-select
            id="sensor-filtro"
            v-model="filtro.offset"
            name="sensor-filtro"
            @md-selected="fetchSensores"
          >
            <md-option :value="milliseconds(30, 'min')"> 30 min </md-option>
            <md-option :value="milliseconds(1, 'hora')"> 1 hora </md-option>
            <md-option :value="milliseconds(2, 'hora')"> 2 horas </md-option>
            <md-option :value="milliseconds(4, 'hora')"> 4 horas </md-option>
            <md-option :value="milliseconds(8, 'hora')"> 8 horas </md-option>
            <md-option :value="milliseconds(16, 'hora')"> 16 horas </md-option>
            <md-option :value="milliseconds(24, 'hora')"> 24 horas </md-option>
          </md-select>
        </md-field>
      </div>
      <div class="col-12 col-md-3">
        <md-datepicker v-model="filtro.dataInicio" :md-close-on-blur="false">
          <label>Data Inicio</label>
        </md-datepicker>
      </div>
      <div class="col-12 col-md-3">
        <md-datepicker v-model="filtro.dataFinal" :md-close-on-blur="false">
          <label>Data Final</label>
        </md-datepicker>
      </div>
      <div class="col-6 col-md-2">
        <md-button class="md-primary" @click="limparFiltro">
          Tirar Filtro
        </md-button>
      </div>
      <div class="col-6 col-md-2">
        <md-button class="md-primary" @click="fetchSensores">
          Buscar
        </md-button>
      </div>
    </div>
    <md-content v-if="sensores && fetchingSensores === false">
      <div class="row">
        <div
          v-for="[equipamento_id, tipo, data] in sensores"
          :key="equipamento_id + tipo + 'graphic'"
          class="col-12 col-md-6 p-0"
        >
          <graphic-area
            :sensores="data"
            :tipo="tipo"
            :max-value.sync="filtro.dataFinal"
            :min-value.sync="filtro.dataInicio"
            :range="filtro.range || filtro.offset"
            :show-marker="filtro.range <= 28800000"
          />
        </div>
        <br />
        <br /><br />
      </div>
    </md-content>
    <div v-if="fetchingSensores" style="text-align: center">
      <md-progress-spinner
        :md-diameter="150"
        :md-stroke="10"
        md-mode="indeterminate"
      />
    </div>
    <div v-if="!sensores && !fetchingSensores">
      <md-empty-state
        md-rounded
        md-icon="timeline"
        md-label="Equipamento não selecionado"
        md-description="Selecione algum equipamento para ter mais detalhes sobre os sensores"
      />
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
